import DeleteIcon from "@mui/icons-material/Delete";
import { Box, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { useAuth } from "@/src/auth/hooks/useAuth";
import { NoteDTO } from "@/src/types/types";
import { getDateStringDMY, getTimeString } from "@/src/utils/dateUtils";

interface AuctionNoteProps {
  note: NoteDTO;
  onDelete: () => void;
  /** Hides delete regardless of author, for notes that belong to another auction (e.g. history). */
  readOnly?: boolean;
}

const NoteItem = (props: AuctionNoteProps) => {
  const { note, onDelete, readOnly } = props;
  const theme = useTheme();
  const { user } = useAuth();
  const canDelete = !readOnly && user?.id === note.userId;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: 1,
        backgroundColor: theme.palette.semantic.secondary.hover,
        borderRadius: 1,
        p: 2,
        mb: 1.5
      }}
    >
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          variant="body1"
          sx={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word"
          }}
        >
          {note.content}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            mt: 1
          }}
        >
          {note.user.firstName} {note.user.lastName} ·{" "}
          {getDateStringDMY(note.createdAt)} {getTimeString(note.createdAt)}
        </Typography>
      </Box>

      {canDelete && (
        <IconButton onClick={onDelete} aria-label="delete" size="small">
          <DeleteIcon sx={{ fontSize: theme.typography.subtitle1.fontSize }} />
        </IconButton>
      )}
    </Box>
  );
};

export default NoteItem;
